import React, { useCallback, useEffect, useRef, useState } from "react";
import { callAPI, useAPI } from "../../../lib/common";

const initState = (type) => ({
  templates: [],
  type: type,
});

const useTemplateList = (type, category, options) => {
  const [templates, setTemplates] = useState(initState(type));

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Race condition hack:
    let active = true;

    setTemplates(initState(type));
    setLoading(true);

    let url = `/api/webshop/templates/${type}`;
    if (category) {
      url += `/categories/${category}`;
      if (options && options.pictureSet) {
        url += `/subjects/${options.pictureSet.subject.uuid}`;
      }
      console.log("The options", options);
    }

    callAPI(url)
      .then((t) => {
        if (active) {
          setTemplates({
            type: type,
            templates: t,
          });
          setLoading(false);
        }
      })
      .catch((err) => console.log("Error", err));

    return () => {
      active = false;
    };
  }, [type, category, options]);

  return [templates, loading];
};

export default useTemplateList;
